var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search'),_c('Stores'),_c('EditStore'),_c('EditStoreSupplierParams'),_c('EditBrandCondition')],1)}
var staticRenderFns = []

export { render, staticRenderFns }